<template>
    <v-card style="border-radius: 1em;">
      <v-card-title class="justify-center">
        <h1>HISTÓRICO DA CARTEIRA</h1>
      </v-card-title>
      <v-divider></v-divider>
        <v-card-text v-if="carteira" style="height: 30em;">
            <span>Saldo atual:</span>
            <v-divider></v-divider>
            <v-layout justify-center>
                <h1 class="primary--text">{{formatar(carteira.saldo)}}</h1>
            </v-layout>
            <v-divider></v-divider>
            <v-layout column class="mt-2">
                <v-list dense two-line>
                    <v-list-tile v-for="(registro, index) in historico" :key="index" class="mb-2">
                        <v-list-tile-content style="width: 25%;">
                            <v-list-tile-title class="text-xs-center">{{formatar(registro.valor)}}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-content style="width: 75%;">
                            <v-list-tile-title>{{registro.data | formatDate('DD/MM/YYYY')}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{registro.descricao}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <div class="text-xs-center pt-2">
                  <v-pagination color="primary" circle v-model="pagination.page" :length="pages"></v-pagination>
                </div>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn
              block
              color="primary"
              @click="$emit('fechar')"
              flat
              class="mb-1"
            >
              Fechar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['pessoa', 'posto', 'empresa'],
  data () {
    return {
      carteira: null,
      historico: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 5,
        page: 1
      }
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    payload () {
      const payload = {}
      if (this.pessoa) {
        payload.id_pessoa = this.pessoa.id_pessoa
      } else if (this.posto) {
        payload.cnpj_posto = this.posto.cnpj
      } else if (this.empresa) {
        payload.cnpj_empresa = this.empresa.cnpj
      } else return
      return payload
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.pegarHistorico()
      },
      deep: true
    },
    carteira (val) {
      if (val) {
        this.pegarHistorico()
      } else {
        this.historico = []
        this.totalItems = 0
      }
    }
  },
  beforeMount () {
    if (this.pessoa || this.posto || this.empresa) {
      this.carteiraVirtual()
      if (this.carteira) this.pegarHistorico()
    }
  },
  methods: {
    carteiraVirtual () {
      this.$store.dispatch('pegarCarteiraVirtual', this.payload).then(json => {
        this.carteira = json
      })
    },
    pegarHistorico () {
      const data = {
        page: this.pagination.page,
        id_carteira: this.carteira.id,
        carteira_virtual__is_cashposto: false
      }

      this.$store.dispatch('pegarHistoricoDaCarteiraVirtual', data
      ).then(json => {
        this.historico = json.results
        this.totalItems = json.count
      })
    },
    formatar (valor) {
        if (valor === undefined) return 'R$ 0,00'
        if (valor === null) return 'R$ 0,00'
        if (valor === 0) return 'R$ 0,00'
        return `R$ ${valor.replace('.', ',')}`
    }
  }
}
</script>
